import { Text } from '@viapeople/components'

export function CalibrationLoading() {
	return (
		<main className='w-full p-6'>
			<div className='flex items-center justify-center py-8'>
				<Text>Loading calibration data...</Text>
			</div>
		</main>
	)
}
